define("shared/components/shared/social/facebook-page", ["exports", "@ember/component", "@ember/template-factory"], function (_exports, _component, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-classic-decorator",0,"@ember/component",0,"@ember/template-factory"eaimeta@70e063a35619d71f

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <a class="o--btn o--btn--outline o--btn--block u--inline" {{on "click" @addPage}}>
    <div class="o--user">
      <img class="o--user__avatar is--square" src={{@page.picture.data.url}} >
      <span class="o--user__title u--p__t__sm">{{if @page.name_with_location_descriptor @page.name_with_location_descriptor @page.name}}</span>
    </div>
  </a>
  
  */
  {
    "id": "yqqztqWB",
    "block": "[[[11,3],[24,0,\"o--btn o--btn--outline o--btn--block u--inline\"],[4,[38,0],[\"click\",[30,1]],null],[12],[1,\"\\n  \"],[10,0],[14,0,\"o--user\"],[12],[1,\"\\n    \"],[10,\"img\"],[14,0,\"o--user__avatar is--square\"],[15,\"src\",[30,2,[\"picture\",\"data\",\"url\"]]],[12],[13],[1,\"\\n    \"],[10,1],[14,0,\"o--user__title u--p__t__sm\"],[12],[1,[52,[30,2,[\"name_with_location_descriptor\"]],[30,2,[\"name_with_location_descriptor\"]],[30,2,[\"name\"]]]],[13],[1,\"\\n  \"],[13],[1,\"\\n\"],[13],[1,\"\\n\"]],[\"@addPage\",\"@page\"],false,[\"on\",\"if\"]]",
    "moduleName": "shared/components/shared/social/facebook-page.hbs",
    "isStrictMode": false
  });

  class FacebookPage extends _component.default {}

  _exports.default = FacebookPage;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, FacebookPage);
});